import { getDocument } from './getDocument.js';
import { getDefaultView } from './getDefaultView.js';

/**
 * Creates a `KeyboardEvent` in a way that also works on IE 11.
 *
 * @example
 * import { createKeyboardEvent } from "reakit-utils";
 *
 * const el = document.getElementById("id");
 * el.dispatchEvent(createKeyboardEvent(el, "keydown", { key: "ArrowDown" }));
 */

function createKeyboardEvent(element, type, eventInit) {
  if (eventInit === void 0) {
    eventInit = {};
  }

  if (typeof KeyboardEvent === "function") {
    return new KeyboardEvent(type, eventInit);
  } // IE 11 doesn't support Event constructors


  var event = getDocument(element).createEvent("KeyboardEvent");
  event.initKeyboardEvent(type, eventInit.bubbles, eventInit.cancelable, getDefaultView(element), eventInit.key, eventInit.location, eventInit.ctrlKey, eventInit.altKey, eventInit.shiftKey, eventInit.metaKey);
  return event;
}

export { createKeyboardEvent };
